import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/notificationPreference.ts
/**
* Mirror of `UserNotificationPushCategory` from the server's
* `zodSchema/userNotificationSetting.ts`. Kept inline so the contract
* package stays free of server-only `zodSchema/` imports; canonical
* definition stays on the server alongside the Prisma JSONB type
* generator wiring.
*/
const userNotificationPushCategoryEnum = z.enum([
	"LIKE",
	"COMMENT",
	"TASK",
	"FOLLOW",
	"NEWS",
	"CONTEST"
]);
const userNotificationPushCategoriesSchema = z.record(userNotificationPushCategoryEnum, z.boolean().optional());
const notificationPreferenceSchema = z.object({
	pushEnabled: z.boolean(),
	pushCategories: userNotificationPushCategoriesSchema
});
const notificationPreferenceContract = oc.prefix("/user/me/notification").tag("UserNotificationPreference").router({
	getNotificationPreference: oc.route({
		summary: "Get push notification preferences for the current user",
		method: "GET",
		path: "/preferences"
	}).output(notificationPreferenceSchema).errors({ UNAUTHORIZED: {
		status: 401,
		message: "User not authenticated"
	} }),
	setNotificationPreference: oc.route({
		summary: "Update push notification preferences for the current user",
		method: "PUT",
		path: "/preferences"
	}).input(z.object({
		pushEnabled: z.boolean().optional(),
		pushCategories: z.record(userNotificationPushCategoryEnum, z.boolean()).optional()
	})).output(notificationPreferenceSchema).errors({ UNAUTHORIZED: {
		status: 401,
		message: "User not authenticated"
	} })
});
//#endregion
export { notificationPreferenceContract };
